import './index.less';
import '@public/images/menunav.jpg';
import '@public/images/rechercher-jt.jpg';
import '@public/images/home/play.png';
import '@public/images/home/index-bg.jpg';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('main-container'));
